import * as Sebrae from '@sebrae/react-core';
import * as React from 'react';
import {
  ENDPOINT__VALIDATE_NAME_REGIONAL,
  ENDPOINT_ACTIVE_REGIONAL,
  ENDPOINT_ALL_REGIONALS,
  ENDPOINT_CREATE_REGIONAL,
  ENDPOINT_GET_ALL_REGIONALS,
  ENDPOINT_UPDATE_REGIONAL,
} from './constants';

export function useRegionalService() {
  const { backendGet, backendPost, backendPut } = Sebrae.useBackend();

  const {
    fetchData: fetchRegional,
    data,
    loading,
    error,
  } = Sebrae.usePagination(`${ENDPOINT_GET_ALL_REGIONALS}`);

  const returnValidateRegionalName = React.useCallback(
    (idUf, nameRegional) =>
      backendGet(`${ENDPOINT__VALIDATE_NAME_REGIONAL}/${idUf}/${nameRegional}`),
    [backendGet],
  );

  const saveReginal = React.useCallback(
    (data = {}) => {
      return backendPost(`${ENDPOINT_CREATE_REGIONAL}`, data);
    },
    [backendPost],
  );

  const updateReginal = React.useCallback(
    (data = {}, id) => {
      return backendPut(`${ENDPOINT_UPDATE_REGIONAL}/${id}`, data);
    },
    [backendPut],
  );

  const changeStatusRegional = React.useCallback(
    (id, status) =>
      backendPut(`${ENDPOINT_ACTIVE_REGIONAL}/${id}/status/${status}`),
    [backendPut],
  );

  const returnRegionals = React.useCallback(
    (data) => backendGet(`${ENDPOINT_ALL_REGIONALS}`, data),
    [backendGet],
  );

  return {
    returnValidateRegionalName,
    changeStatusRegional,
    fetchRegional,
    data,
    loading,
    error,
    saveReginal,
    updateReginal,
    returnRegionals,
  };
}
